import * as ACTION_TYPES from './Types';

const initialState = {
  brandmenus:{},
  message: '',
  error: null,
}

export const brandmenuReducer = (state = initialState, action) => {
  switch (action.type) {
    
    case ACTION_TYPES.GETBRANDMENU_SUCCESS:  
      return {
          ...state,
          brandmenus:action.payload.data,
          message: action.payload.message,
      }

    case ACTION_TYPES.GETBRANDMENU_ERROR:
      return {
        ...state,
        message: action.payload.message,
      } 
    case ACTION_TYPES.ADDBRANDMENU_SUCCESS:
    case ACTION_TYPES.UPDATEBRANDMENU_SUCCESS:  
    case ACTION_TYPES.CHANGEACTION_SUCCESS:
      return {
          ...state,
          brandmenus:action.payload.data,
          message: action.payload.message,
      }

    case ACTION_TYPES.ADDBRANDMENU_ERROR:
    case ACTION_TYPES.UPDATEBRANDMENU_ERROR:
    case ACTION_TYPES.CHANGEACTION_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }               
        
    default:
      return state;
  }
}
